import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponse } from "@biletix/core/models/api-response";
import { BtxArtistInfoForArtistListPageDTO } from "@biletix/core/models/event/artist-info-for-artist-list-page.model";
import { ApiService } from "@biletix/core/services/api.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class ArtistService {

  private eventBasePath: string = "/api/v1/bxcached/event";

  constructor(private http: HttpClient, private apiService: ApiService) {
  }

  getAllArtistsWithPerformanceCount(page: number = 0): Observable<BtxArtistInfoForArtistListPageDTO[]> {
    return this.http
      .get<ApiResponse<BtxArtistInfoForArtistListPageDTO[]>>(
        `${this.apiService.getCrmApiHost()}${this.eventBasePath}/getArtistsForArtistPage`,
        { params: new HttpParams().set('page', page) }
      )
      .pipe(map(response => response.data));
  }

  searchArtistsByName(name: string, page: number = 0): Observable<BtxArtistInfoForArtistListPageDTO[]> {
    // HttpParams değeri encode eder: sanatçı adındaki boşluk, '&' ve Türkçe
    // karakterler string interpolation ile bozuk bir query üretiyordu.
    return this.http
      .get<ApiResponse<BtxArtistInfoForArtistListPageDTO[]>>(
        `${this.apiService.getCrmApiHost()}${this.eventBasePath}/getArtistsForSearch`,
        { params: new HttpParams().set('name', name).set('page', page) }
      )
      .pipe(map(response => response.data));
  }
}
